import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { isUUID } from "@/common/utils/orgRouteUtils";
import { Storage } from "@/common/utils/storage";

export const Route = createFileRoute("/_org/org/$orgId")({
  params: {
    parse: (params: { orgId: string }) => {
      if (!isUUID(params.orgId)) {
        throw new Error("Invalid orgId");
      }
      return params;
    },
    stringify: (params: { orgId: string }) => params,
  },
  beforeLoad: async ({ params, context, location, search }) => {
    const { orgId } = params;
    const { organizations, savedOrgBusinessUnit } = context as {
      organizations: {
        id: string;
        name: string;
        businessUnits: { id: string; name: string; permissions: string[] }[];
      }[];
      savedOrgBusinessUnit?: { id: string };
    };

    const currentOrg = organizations?.find((o) => o.id === orgId);

    if (!currentOrg) {
      // User doesn't have access to this org (stale URL): fall back to their
      // own default org and business unit.
      throw redirect({ to: "/org" });
    }

    // Save as last-used org
    await Storage.setItem("selectedOrgId", currentOrg.id);

    // Determine business unit
    const selectedBUId = savedOrgBusinessUnit?.id;
    const currentOrgBusinessUnit =
      currentOrg.businessUnits?.find((bu) => bu.id === selectedBUId) ??
      currentOrg.businessUnits?.[0];

    if (currentOrgBusinessUnit) {
      const restPath = location.pathname.replace(`/org/${orgId}`, "") || "";
      throw redirect({
        to: `/org/bu/${currentOrgBusinessUnit.id}${restPath}` as string as "/",
        search,
      });
    }

    return {
      currentOrg,
      currentOrgBusinessUnit,
    };
  },
  component: () => <Outlet />,
});
